// used in auth login

import Input from '../inputFormik';

const AskForgot = ({ setAuth, t }) => {
  return (
    <div className='flex items-center justify-between text-[18px]'>
      <div className='flex items-center gap-1.5 lg:gap-3'>
        <Input
          type='checkbox'
          name='rememberMe'
          title={t('Remember Me?')}
          labelClassName='max-sm:!text-[13px]'
        />
      </div>
      <button
        type='button'
        onClick={() => setAuth('forgot-mobile')}
        className='cursor-pointer font-bold underline max-lg:text-sm max-sm:text-xs'
      >
        {t('Forgot Password?')}
      </button>
    </div>
  );
};

export default AskForgot;
